import { render, staticRenderFns } from "./PrerequisiteTable.vue?vue&type=template&id=d6e1fdf0&"
import script from "./PrerequisiteTable.vue?vue&type=script&lang=js&"
export * from "./PrerequisiteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports